// English copy
export default {
  common: {
    listSeparator: ', ',
    companyName: 'Beijing Shunshi Zhongjie Technology Co., Ltd.',
    brandName: 'Shunshi Zhongjie',
    altPhone: 'Phone',
    altAddress: 'Address',
    altWechatWork: 'WeCom QR Code',
    altOfficial: 'Official Account QR Code',
    altProduct: 'Product Display',
    altWorkflow: 'Zhongsheng 2.0 Workflow'
  },
  nav: {
    home: 'Home',
    productCenter: 'Products',
    advantage: 'Advantages',
    solution: 'Solutions',
    solutionMobile: 'Solutions',
    faq: 'FAQ',
    about: 'About Us',
    apply: 'Apply for Trial',
    applyMobile: 'Apply Now'
  },
  lang: {
    zh: '中文',
    en: 'English'
  },
  solution: {
    common: {
      tryNow: 'Try Now',
      industryPainPoints: 'Industry Pain Points',
      coreAbilities: 'Core Capabilities',
      valueRealization: 'Value Realized'
    },
    car: {
      title: 'Automotive',
      bannerTitle: ['AI Voice Drives Automotive Marketing', 'Building a full acquisition-conversion-after-sales growth loop'],
      sectionTitle: 'AI voice empowers automotive marketing and reshapes digital customer operations',
      painPoints: [
        { title: 'Labor Dilemma', desc: 'Outbound calling relies on human agents, keeping labor costs persistently high.' },
        { title: 'Poor Business Elasticity', desc: 'Hard to scale staff up or down across seasons, causing resource waste or slow response.' },
        { title: 'Sales Bottlenecks', desc: 'Long order follow-up cycles and weak manual follow-up; low conversion from price comparison and test drives.' },
        { title: 'High After-sales Attrition', desc: 'Maintenance, appointments and renewals rely on manual work; missed follow-up leads to customer churn.' }
      ],
      solutions: [
        {
          title: 'AI Intelligent Outbound Acquisition & Elastic Operations',
          coreAbilities: [
            { title: 'High-concurrency intelligent outbound', desc: 'AI replaces human agents with unlimited daily capacity, completely breaking manual outbound limits' },
            { title: 'Flexible outbound hours', desc: 'Ready on demand; adjust call times anytime to easily handle peak and off-peak fluctuations' }
          ],
          values: [
            { title: 'Near-zero operating cost', desc: 'Completely avoids the combined costs of agents, recruiting, offices and team management' },
            { title: 'Improved business elasticity', desc: 'Breaks manual outbound caps and time constraints, making business growth more flexible' }
          ]
        },
        {
          title: 'AI Sales Conversion & Intelligent Data Decisions',
          coreAbilities: [
            { title: 'Real-time conversational semantic analysis', desc: 'Auto-generates intent scores and demand tags (price-sensitive, competitor comparison, etc.)' },
            { title: 'Data-driven strategy optimization', desc: 'Aggregate tag analysis precisely guides marketing scripts and product strategy' }
          ],
          values: [
            { title: 'Multiplied sales efficiency', desc: 'Know the customer profile the moment you connect, adjusting scripts in real time to close deals' },
            { title: 'Zero wasted leads', desc: 'Low-scoring leads automatically enter nurture sequences, avoiding any lost opportunity' }
          ]
        },
        {
          title: 'AI Customer Lifecycle Management & Precise Renewal',
          coreAbilities: [
            { title: 'Full-volume bulk customer outreach', desc: 'AI covers existing customers that manual work can hardly reach' },
            { title: 'Precise marketing & intelligent follow-up', desc: 'Precise push based on customer history (model, maintenance cycle, insurance expiry)' }
          ],
          values: [
            { title: 'Doubled customer coverage', desc: 'AI outbound greatly expands the reach and frequency of existing customers' },
            { title: 'Multiplied renewal conversion', desc: 'Intelligent follow-up significantly lifts renewal success and conversion' }
          ]
        }
      ],
      hero: {
        tag: 'Outbound AI Voice System',
        titleLine1: 'Break through the bottleneck of manual lead screening',
        titleLine2: 'Drive new automotive sales growth with AI',
        descLine1: 'Obtain multi-field key information through multi-turn Q&A, solving the entire process from production to delivery in one stop',
        descLine2: 'Help automakers cut costs, boost growth and lift efficiency, achieving both compliance and returns'
      },
      pain: {
        sectionTitle: 'Manual telemarketing shortcomings are eating into automaker profits',
        items: [
          { title: 'Management Difficulty', desc: 'Lack of standardized processes and over-reliance on individual ability creates a broken conversion funnel' },
          { title: 'Low Efficiency', desc: 'Sales reps average only 200 calls per day, wasting time and making it hard to reach high-intent customers' },
          { title: 'High Costs', desc: 'Daily per-person cost approaches ¥200, heavy labor investment with low conversion output' },
          { title: 'Compliance Risks', desc: 'Non-standard authorization scripts lead to incomplete consent and legal risks.' }
        ]
      },
      flow: {
        sectionTitle: 'AI-driven automotive lead marketing system',
        sectionSub: 'Centered on an AI voice application model, building a fully automated platform for inviting and managing new-car customers',
        steps: [
          { title: 'Intelligent Dialogue Engine', desc: 'Human-like multi-turn interaction with precise purchase-intent recognition' },
          { title: 'Full-process Automation', desc: 'Fully automatic from data intake to return, and from collection to lead quantification' },
          { title: 'Timely Data Sync', desc: 'Connects data flows across every stage to ensure information consistency' },
          { title: 'Configurable Script Management', desc: 'Flexibly customizable dialogue strategies to fit different scenarios and brand styles' },
          { title: 'Multi-tenant Architecture', desc: 'Meets multi-brand management needs with personalized operational settings' }
        ]
      },
      autoData: {
        sectionTitle: 'Full-process automation and intelligent data management',
        left: ['Batch Lead Import', 'One-click Outbound Call', 'End-to-end Auto Outreach'],
        right: ['Key Information Extraction', 'Lead Cleaning & Distribution', 'Closed-loop Process Management']
      },
      portrait: {
        sectionTitle: 'Customer Profiling',
        cards: [
          { icon: 'red', title: 'Key Field Recognition', lines: ['Brand and model', 'Province and city', 'Authorization information'] },
          { icon: 'purple', title: 'Purchase Behavior Analysis', lines: ['Purchase timing, identifying intent', 'Purchase method, distinguishing', 'Full payment, loan or trade-in'] },
          { icon: 'red-voice', title: 'User Identity Tagging', lines: ['Surname extraction for personalized address', 'Phone number as unique identifier', 'Lead tracking and deduplication'] },
          { icon: 'blue-ai', title: 'AI Dialogue Interaction', lines: ['Multi-turn dialogue, step-by-step confirmation', 'Authentic user information', 'Accurately parse user intent'] },
          { icon: 'green-voice', title: 'Data Validity Check', lines: ['Filter jokes and clearly', 'non-purchase-intent content', 'Identify non-target groups'] },
          { icon: 'blue-doc', title: 'Intelligent Deduplication', lines: ['Merge the same user by phone number', 'Prevent duplicate follow-ups', 'Behavioral feature comparison'] }
        ]
      },
      sop: {
        sectionTitle: 'Tiered Follow-up Strategy SOP',
        levels: [
          { name: 'A-tier Lead', desc: 'High intent, immediately assigned to sales for follow-up' },
          { name: 'B-tier Lead', desc: 'Medium intent, follow up within 24 hours' },
          { name: 'C-tier Lead', desc: 'Low intent, nurture within 3 days' }
        ],
        tip: 'Multi-dimensional Comparison',
        scoreTitle: 'Quantified Score',
        rate: '↗ 41.67%',
        radar: ['Purchase Urgency', 'Budget Match', 'Demand Clarity', 'Auth Integrity', 'Historical Interaction'],
        consult: 'Consult Now'
      },
      scene: {
        title: 'Shunshi AI, full coverage of automotive lead marketing scenarios',
        items: [
          { title: 'New Car Launch Invitation', desc: 'Quickly filter massive leads, precisely identify high-intent customers and assign them to top sales reps for priority follow-up.' },
          { title: 'Auto Show / Large Event Invitation', desc: 'Run large-scale warm-up invitations, intelligently screen attendance intent and auto-send event reminders.' },
          { title: 'Daily Test-drive Invitation', desc: 'Automatically handle test-drive requests and sync them to sales schedules for process automation.' },
          { title: 'Customer Care & Re-marketing', desc: 'Automatically reach and nurture C/D-tier leads on a regular basis, maintaining customer stickiness at low cost.' }
        ]
      }
    },
    finance: {
      title: 'Finance',
      bannerTitle: ['AI Voice Empowers Financial Intelligent Service', 'Building a multi-scenario loop across marketing, risk and collections'],
      sectionTitle: 'AI voice empowers core financial business scenarios and drives intelligent service upgrades',
      painPoints: [
        { title: 'High Labor Costs', desc: 'Agents average under 300 outbound calls daily; labor costs exceed 60% of budget' },
        { title: 'Severe Compliance Risk', desc: 'Script deviations cause customer complaints, crossing consumer-protection red lines' },
        { title: 'Low Data Utilization', desc: 'Most institutions cannot link outbound data with customer profiles and product holdings in real time' },
        { title: 'Insufficient Service Efficiency', desc: 'Traditional IVR responds slowly; long wait times lower satisfaction' }
      ],
      solutions: [
        {
          title: 'Intelligent Customer Service & Business Consultation',
          coreAbilities: [
            { title: '24/7 round-the-clock service', desc: 'Supports 24/7 service for standardized tasks like balance checks, inquiries and transaction guidance' },
            { title: 'Multi-dimensional perception & intelligent response', desc: 'Senses intent, emotion and dialect, auto-matching flows and switching comforting scripts to cut transfers' }
          ],
          values: [
            { title: 'Leaping service efficiency', desc: 'Daily inquiries per agent grow from 300 to unlimited; customer wait time cut by 70%' },
            { title: 'Sharply lower transfer rate', desc: 'Greatly reduces transfers and complaints, boosting automation and satisfaction' }
          ]
        },
        {
          title: 'Precise Marketing of Financial Products',
          coreAbilities: [
            { title: 'Multi-dimensional data integration', desc: 'Integrates transaction history and risk preferences to generate personalized scripts' },
            { title: 'Real-time strategy optimization', desc: 'Adjusts outbound strategy based on connect rates and response times' }
          ],
          values: [
            { title: 'Improved lead conversion', desc: 'Precisely handles different interaction scenarios to lift outbound conversion' },
            { title: 'Multiplied high-net-worth conversion', desc: 'Product recommendation conversion and repurchase rates rise markedly' }
          ]
        },
        {
          title: 'Risk Warning & Compliance Management',
          coreAbilities: [
            { title: 'Real-time risk monitoring', desc: 'Auto-mines sensitive words and risk events, triggering instant alerts' },
            { title: 'Compliance comparison & record retention', desc: 'Real-time voice comparison auto-flags violations and generates tamper-proof decision and operation logs' }
          ],
          values: [
            { title: 'Effectively reduced fraud loss', desc: 'Auto-identifies abnormal transactions, significantly cutting monthly fraud loss' },
            { title: '100% compliance guarantee', desc: 'Strictly adheres to legal hours and auto-avoids prohibited periods; history meets audit requirements' }
          ]
        },
        {
          title: 'Warm Collections & Repayment Reminders',
          coreAbilities: [
            { title: 'Differentiated collection strategy engine', desc: 'Personalized collection strategies based on repayment ability and overdue days' },
            { title: 'Emotional intelligence optimization', desc: 'Real-time analysis of customer emotion to dynamically adjust scripts and reduce resistance' }
          ],
          values: [
            { title: 'Multiplied collection efficiency', desc: 'AI daily volume is dozens of times manual, focusing on complex cases' },
            { title: 'Significantly higher repayment rates', desc: 'Intelligent analysis adjusts strategy in real time, effectively lifting repayment' }
          ]
        }
      ]
    },
    education: {
      title: 'Education',
      bannerTitle: ['AI Voice Empowers Education', 'Building a closed loop across acquisition and operations'],
      sectionTitle: 'AI voice empowers education admissions and operations, lifting full-cycle conversion',
      painPoints: [
        { title: 'Rising Acquisition Costs', desc: 'Fierce competition and inefficient traditional enrollment drive up costs' },
        { title: 'Human Efficiency Bottleneck', desc: 'Limited daily outbound calls; new-staff training takes up to 2 weeks; high turnover' },
        { title: 'Uneven Service Experience', desc: 'Off-hours inquiries cannot be answered promptly; parent satisfaction fluctuates' },
        { title: 'Severe Data Gaps', desc: 'Student intent and follow-up progress are hard to accumulate; low renewal conversion' }
      ],
      solutions: [
        {
          title: 'AI Enrollment & Intelligent Lead Screening',
          coreAbilities: [
            { title: 'Ultra-high concurrent outbound', desc: 'Supports 500+ concurrent calls with unlimited daily capacity, dozens of times manual efficiency' },
            { title: 'Precise intent scoring', desc: 'Precise scoring on course needs, budget range and decision cycle' }
          ],
          values: [
            { title: 'Sharply lower enrollment cost', desc: 'Cuts agent costs in the outbound stage for cost reduction and efficiency' },
            { title: 'Notably higher lead quality', desc: 'Accurately screens high-intent customers, laying the foundation for conversion' }
          ]
        },
        {
          title: 'AI Full-lifecycle Operations & Renewal Management',
          coreAbilities: [
            { title: 'Full-dimensional data integration', desc: 'Integrates student data and interaction records into a unified view' },
            { title: 'Intelligent segmentation & churn warning', desc: 'Builds precise profiles from learning behavior to auto-identify churn risks' }
          ],
          values: [
            { title: 'Markedly fewer operations staff', desc: 'Higher data accuracy and lower manual operations cost' },
            { title: 'Effectively higher renewal rate', desc: 'Personalized renewal plans based on learning data boost renewals' }
          ]
        }
      ]
    },
    insurance: {
      title: 'Insurance',
      bannerTitle: ['AI Voice Empowers Insurance Intelligent Service', 'Covering the full business chain of claims, acquisition and follow-up'],
      sectionTitle: 'AI voice empowers key insurance scenarios and lifts service efficiency and compliance',
      painPoints: [
        { title: 'Surging Operating Costs', desc: 'Marketing, labor and process costs keep rising year after year' },
        { title: 'Compliance vs. Responsiveness', desc: 'Under strict regulation, tightening compliance conflicts with dynamic response capability' },
        { title: 'Complex Claims Process', desc: 'Manual claims take long, extending customer wait and lowering satisfaction' },
        { title: 'Severe Data Silos', desc: 'Data gaps across underwriting, claims and service hinder fine-grained operations' }
      ],
      solutions: [
        {
          title: 'AI Intelligent Claim Notices & Full-process Automation',
          coreAbilities: [
            { title: 'Highly human-like TTS synthesis', desc: 'Near-human interaction greatly reduces agent headcount' },
            { title: 'Fully automated claims process', desc: 'Intelligent notifications covering filing, review and payout' }
          ],
          values: [
            { title: 'Dual improvement in claim efficiency & quality', desc: 'Less manual intervention and markedly higher processing efficiency' },
            { title: 'Stronger customer experience & trust', desc: 'Timely, accurate claim updates raise satisfaction' }
          ]
        },
        {
          title: 'AI Precise Acquisition Marketing & Customer Segmentation',
          coreAbilities: [
            { title: 'Precise customer segmentation', desc: 'Intelligent multi-dimensional layering to identify high-intent groups' },
            { title: 'Dynamic benefit matching', desc: 'Smartly matches optimal plans and suggestions to customer profiles' }
          ],
          values: [
            { title: 'Effectively lower acquisition cost', desc: 'Precise reach reduces wasted outbound; marketing ROI rises markedly' },
            { title: 'Multiplied lead conversion', desc: 'Accurate high-intent screening boosts sales conversion' }
          ]
        },
        {
          title: 'AI Intelligent Policy Follow-up & Compliant Data Collection',
          coreAbilities: [
            { title: 'Intelligent customer-intent collection', desc: 'Auto-collects feedback and intent into trackable leads' },
            { title: 'Automated compliant processes', desc: 'Standardized flow ensures 100% compliance and zero violations' }
          ],
          values: [
            { title: '100% compliance guarantee', desc: 'Full-process QA meets regulatory red lines' },
            { title: 'Deeper opportunity mining', desc: 'Intent leads from follow-ups are far better utilized' }
          ]
        }
      ]
    },
    commerce: {
      title: 'E-commerce',
      bannerTitle: ['AI Voice Empowers E-commerce Intelligent Operations', 'Building multi-channel growth across sales, private domain and after-sales'],
      sectionTitle: 'AI voice empowers core e-commerce scenarios and lifts full-lifecycle customer value',
      painPoints: [
        { title: 'High Labor Costs', desc: 'Large headcount with obvious peak-and-trough demand differences' },
        { title: 'Conversion Bottleneck', desc: 'Low manual outbound conversion; limited daily calls per salesperson' },
        { title: 'Severe Customer Churn', desc: 'Slow follow-up and after-sales response lower satisfaction' },
        { title: 'Severe Data Silos', desc: 'Behavior, transaction and service data are scattered, limiting marketing' }
      ],
      solutions: [
        {
          title: 'AI Sales Conversion & Intelligent Order Recovery',
          coreAbilities: [
            { title: 'Ultra-high concurrent elastic outbound', desc: 'Unlimited daily capacity to handle massive peak-season demand' },
            { title: 'Real-time semantic intent scoring', desc: 'Real-time purchase-intent grading via call semantics' }
          ],
          values: [
            { title: 'Sharply higher sales conversion', desc: 'Intelligent outbound converts far better than manual, with notable order growth' },
            { title: 'Optimized labor costs', desc: 'Smaller sales team and lower labor share for cost reduction and efficiency' }
          ]
        },
        {
          title: 'AI Private-domain Operations & Precise Customer Activation',
          coreAbilities: [
            { title: 'Intelligent layered precise outreach', desc: 'Layering by intent scores with differentiated strategies and scripts' },
            { title: 'Intelligent purchase-cycle reminders', desc: 'Push repurchase reminders and offers based on cycle and habits' }
          ],
          values: [
            { title: 'Notably higher repurchase rate', desc: 'Smart reminders effectively grow repurchases' },
            { title: 'Multiplied private-domain conversion', desc: 'Higher conversion and improved community activity' }
          ]
        },
        {
          title: 'AI After-sales Follow-up & Intelligent Customer Care',
          coreAbilities: [
            { title: 'Intelligent satisfaction follow-up', desc: 'Automatic surveys and feedback collection after order completion' },
            { title: 'Intelligent issue detection & transfer', desc: 'Auto-detects complaints via voice analysis and promptly transfers to humans' }
          ],
          values: [
            { title: 'Higher customer satisfaction', desc: '100% follow-up coverage with prompt issue resolution' },
            { title: 'Multiplied complaint-handling efficiency', desc: 'Auto-classification greatly speeds complaint handling' }
          ]
        }
      ]
    },
    government: {
      title: 'Government',
      bannerTitle: ['AI Voice Empowers Smart Government Services', 'Building a multi-scenario solution across consulting, publicity and surveys'],
      sectionTitle: 'AI voice empowers core government service scenarios and lifts public-service efficiency',
      painPoints: [
        { title: 'Tight Service Resources', desc: 'Work hours and staffing limit responsiveness, hitting a service bottleneck' },
        { title: 'Hard Data Integration', desc: 'Department systems are siloed with poor sharing and weak data support' },
        { title: 'Hard Information Reach', desc: 'Policy and emergency notices are hard to deliver to the public quickly' },
        { title: 'Hard Public-opinion Collection', desc: 'Traditional surveys are costly, slow and small-sample, making public needs hard to grasp' }
      ],
      solutions: [
        {
          title: 'AI Government Service Consulting & Multi-turn Dialogue',
          coreAbilities: [
            { title: 'Deep government knowledge-base integration', desc: 'Unifies policies, regulations and procedures into one knowledge base' },
            { title: 'Multi-turn understanding & transfer', desc: 'Accurately understands needs, provides precise answers and auto-transfers complex issues' }
          ],
          values: [
            { title: 'Promoted data sharing', desc: 'Breaks information silos to advance integrated government services' },
            { title: '24/7 uninterrupted service', desc: 'Relieves staff pressure, lifts efficiency and public satisfaction' }
          ]
        },
        {
          title: 'AI Policy Publicity & Emergency Notice Delivery',
          coreAbilities: [
            { title: 'Million-level bulk outreach', desc: 'Reaches millions to ensure timely delivery of important information' },
            { title: 'Precise multi-dimensional targeting', desc: 'Precise push by region, age, occupation and more' }
          ],
          values: [
            { title: 'Significantly higher coverage', desc: 'No blind spots in policy and emergency notices' },
            { title: 'Sharply lower communication cost', desc: 'Far lower cost and notably higher efficiency than traditional methods' }
          ]
        },
        {
          title: 'AI Public-opinion Surveys & Real-time Sentiment Analysis',
          coreAbilities: [
            { title: 'Intelligent questionnaire generation', desc: 'Custom questionnaires with open-ended and multiple-choice items' },
            { title: 'Real-time analytics reports', desc: 'Real-time analysis auto-generates trend reports and hotspot detection' }
          ],
          values: [
            { title: 'Leaping survey efficiency', desc: 'Weeks of surveys shrink to days, dozens of times faster' },
            { title: 'Significantly larger samples', desc: 'Samples grow from thousands to millions, strengthening representativeness' }
          ]
        }
      ],
      hero: {
        tag: 'AI Government Consultation Platform',
        titleLine1: 'Purpose-built for government agencies',
        titleLine2: 'a 24/7 intelligent hotline solution',
        descLine1: 'Empower government and enterprise units to achieve digital transformation and build an intelligent, convenient,',
        descLine2: 'efficient and secure service platform'
      },
      demand: {
        sectionTitle: 'Core Needs of Government & Enterprise Units',
        items: [
          { title: 'Boost service efficiency and satisfaction', desc: 'Inquiries and processing volumes keep growing and are highly repetitive, urgently requiring digital products to raise per-capita efficiency' },
          { title: 'Bridge online and offline services', desc: 'Relieve offline service pressure on government departments and let the public resolve common issues online by themselves' },
          { title: 'Ensure product and data security', desc: "Product compliance and security, with customizable private deployment tailored to each unit's business processes" },
          { title: 'Reduce human service costs', desc: 'Building an in-house service team is costly and hard to manage; an integrated service solution is more necessary' }
        ]
      },
      solve: {
        title: 'Shunshi AI Intelligent Public Service Solution'
      },
      caseStudy: {
        badgeLine1: 'Beijing',
        badgeLine2: 'Dongcheng District',
        street: 'Yongwai Sub-district',
        streetEn: 'Yongwai Sub-district',
        tag: 'AI Government Consultation Platform',
        title: 'Successfully deployed at Yongwai Sub-district, Dongcheng District, Beijing',
        quote: "\"After the AI system was deployed, residents' night-time inquiries were answered promptly, and high-frequency questions were handled uniformly by AI, relieving window pressure and letting us focus on complex cases.\" — Project Lead"
      },
      feature: {
        consult: 'Consult Now',
        tryFree: 'Free Trial',
        rows: [
          {
            titleLine1: 'Effortlessly build a knowledge base',
            titleLine2: 'Say goodbye to tedious knowledge training',
            items: [
              'Knowledge base covers 95% of high-frequency inquiry categories',
              'Covers 9 major business areas including self-heating subsidies, social insurance, pension insurance and subsistence allowance policies, fully covering sub-district office service scenarios'
            ]
          },
          {
            titleLine1: 'Intelligent service hotline',
            titleLine2: 'Greatly improving service efficiency and satisfaction',
            items: [
              '7×24 intelligent phone support',
              'Multi-turn dialogue and understanding with intent recognition',
              'High-concurrency incoming lines with zero wait for public inquiries'
            ]
          },
          {
            titleLine1: 'Intelligent data analysis and closed-loop business handling',
            subTitle: 'Relieving offline service pressure on government departments',
            items: [
              'Automatic call transcription and intelligent work-order filling',
              'Automatically aggregate and analyze all inquiry data and generate analysis reports',
              'Reduce human agent involvement and free up high-value staff'
            ]
          }
        ]
      },
      scene: {
        title: 'Shunshi AI, full coverage of government and enterprise service scenarios',
        items: [
          { title: 'Policy Consultation', desc: 'Timely answers on procedures and precise policy interpretation' },
          { title: 'Progress Inquiry', desc: 'Smart inquiry of approval status with real-time notification of document results' },
          { title: 'Complaint Handling', desc: 'Full traceability of complaint registration and prompt emotional reassurance' },
          { title: 'Appointment Management', desc: 'One-click appointment booking with flexible rescheduling' },
          { title: 'Hotline Answering', desc: 'Intelligent routing of public hotlines with round-the-clock emergency response' },
          { title: 'Information Registration', desc: 'Convenient entry of resident information with automatic aggregation of feedback' }
        ]
      }
    },
    homeDecoration: {
      title: 'Home Decoration',
      bannerTitle: ['AI Voice Empowers Home Decoration Intelligent Marketing', 'Building the full chain from acquisition, consulting to referral'],
      sectionTitle: 'AI voice empowers three core home-decoration scenarios and builds a digital marketing loop',
      painPoints: [
        { title: 'High Acquisition Cost', desc: 'Traditional marketing is costly and ineffective, making acquisition hard' },
        { title: 'Low Sales Efficiency', desc: 'Limited manual outbound, long training and unstable teams' },
        { title: 'Slow Service Response', desc: 'Slow response to consultations, site measurement and after-sales needs' },
        { title: 'Hard Lifecycle Management', desc: 'Poor management from intent to signing and referrals' }
      ],
      solutions: [
        {
          title: 'AI Intelligent Acquisition & Precise Lead Screening',
          coreAbilities: [
            { title: 'Elastic handling of peak demand', desc: 'Unlimited daily capacity for delivery peaks and renovation seasons' },
            { title: 'Multi-dimensional intent scoring', desc: 'Precise grading by renovation, budget, decision and layout' }
          ],
          values: [
            { title: 'Sharply lower acquisition cost', desc: 'Fewer traditional ads; cost per lead drops over 50%' },
            { title: 'Notably higher lead quality', desc: 'More accurate high-intent screening and higher conversion' }
          ]
        },
        {
          title: 'AI Home Decoration Consulting & Professional After-sales',
          coreAbilities: [
            { title: 'Integrated decoration knowledge base', desc: 'Unifies process, materials, styles and pricing into a full knowledge system' },
            { title: 'Multi-turn needs analysis', desc: 'Precisely analyzes needs (style, function, budget) through multi-turn dialogue' }
          ],
          values: [
            { title: 'Ultra-fast consulting response', desc: 'Response drops from hours to minutes, lifting satisfaction' },
            { title: 'Optimized labor costs', desc: 'Fewer service staff and better HR utilization' }
          ]
        },
        {
          title: 'AI Customer Retention & Referral Activation',
          coreAbilities: [
            { title: 'Full lifecycle customer management', desc: 'Integrates records, service history and feedback into a complete view' },
            { title: 'Referral mechanism delivery', desc: 'Intelligent follow-up collects feedback, identifies quality customers and pushes referral rewards' }
          ],
          values: [
            { title: 'Significantly higher loyalty', desc: 'Regular care strengthens stickiness; complete profiles power precise marketing' },
            { title: 'Steady referral growth', desc: 'Referral marketing steadily lifts the share of new customers from recommendations' }
          ]
        }
      ]
    },
    law: {
      title: 'Legal',
      hero: {
        tag: 'Outbound AI Voice System',
        titleLine1: 'Full-cycle Legal Consultation',
        titleLine2: 'Case-source Operations & Client Retention Solution',
        desc: 'Significantly reduce routine communication workload for lawyers and markedly boost case-source conversion'
      },
      demand: {
        sectionTitle: 'When communication still relies on manual work, efficiency and professionalism are hard to balance',
        items: [
          { title: 'Manual outbound tasks drive high operating costs', desc: 'Labor costs such as salary, social insurance and bonuses are high; staff turnover adds hidden costs of termination, rehiring and training' },
          { title: 'Manual outbound is inefficient with a capacity ceiling', desc: 'Physiological limits prevent high-intensity case-source outreach, and seats cannot be elastically adjusted across peak and off-peak seasons' },
          { title: 'Manual statistics are error-prone and impair decision-making', desc: 'Reliance on manual entry leads to missed or misrecorded key case information; the whole data chain lacks systematic management, and decisions rely purely on experience' },
          { title: 'High compliance risk and poor service experience', desc: "Lawyers' expertise varies and scripts easily violate rules; time-consuming communication keeps lawyers from focusing on high-value case analysis" }
        ]
      },
      solution: {
        sectionTitle: 'Shunshi AI, a solution for legal consultation scenarios',
        cards: [
          { title: 'A Dedicated AI Legal Assistant for Law Firms', desc: 'Deeply integrates legal terminology and business logic, rejecting generic model answers to ensure professional and compliant front-end consultation' },
          { title: 'Core Architecture', desc: 'Covers high-concurrency intelligent outbound calling, multi-turn dialogue, full call analysis and visualized control, automating the full flow from lead cleaning to intent screening' }
        ]
      },
      chatDemo: {
        tag1: 'Professional Script Library',
        tag2: 'Multi-turn Complex Dialogue',
        tag3: 'Customer Intent Recognition',
        tag4: 'Automatic Scene Jump',
        msg1: 'This is Beijing Law Firm. We have a professional legal team specializing in various cases. Do you have any legal questions to consult?',
        msg2: 'Yes, where are you located?',
        msg3: 'We have multiple branches in Chaoyang, Haidian, Dongcheng, Xicheng and suburban areas.',
        msg4: 'Could you briefly tell me about your situation?'
      },
      feature: {
        sectionTitle: 'Not traditional AI, but your case-source growth assistant',
        consult: 'Consult Now',
        module1: {
          titleLine1: 'One-click Outbound Batch Outreach',
          titleLine2: 'Rapidly Screen Valid Case Sources',
          items: [
            'Supports batch upload of Excel/CSV files and one-click creation of outbound tasks',
            'Supports high concurrency with tens of thousands of calls per day',
            'Matches peak answer times and avoids ineffective dialing windows'
          ],
          caption: 'Intelligent reception rivaling a professional legal assistant'
        },
        module2: {
          titleLine1: 'Full Call Data Analysis',
          titleLine2: 'Generating Analysis Reports & Multi-dimensional Dashboards',
          items: [
            'Full recording and intelligent transcription',
            'Intelligent blocking of invalid inquiries and quantified lead scoring',
            'Auto-generated customer profiling reports',
            'Multi-dimensional data reports'
          ]
        }
      },
      deploy: {
        sectionTitle: 'Go live in one week and integrate seamlessly with your business',
        items: [
          { title: 'Standardized Rapid Delivery', desc: 'From requirement confirmation to official launch in just one week, quickly realizing business value' },
          { title: 'SaaS, Ready Out of the Box', desc: 'Ready to use with an internet connection, greatly reducing IT infrastructure cost and maintenance burden for law firms' },
          { title: 'Seamless Integration with Existing Systems', desc: 'Deeply adapted to mainstream case-management and financial systems of law firms, connecting business flows' }
        ]
      },
      scene: {
        sectionTitle: 'Which scenarios suit replacing manual work with Shunshi AI',
        items: [
          { title: 'Timely Response & Rapid Screening of Multi-channel Case Leads', desc: 'Law firm leads are scattered across channels of uneven quality. Traditional manual screening is extremely inefficient, cannot reach leads within the golden response window (15 minutes), causing severe loss of high-value clients and wasted ad budgets.' },
          { title: 'Case-source Classification & Data Analysis', desc: "Massive customer call information relies on lawyers manually recording in Excel; missed key details and subjectively embellished intent levels distort the data source. Management cannot see channel conversion rates, and decisions lack data support." },
          { title: 'Post-case Satisfaction Follow-up', desc: 'After case closure, a systematic satisfaction survey mechanism is lacking; manual follow-up is inefficient and misses service optimization opportunities.' },
          { title: '24/7 Inbound Consultation for Legal Services', desc: 'Traditionally reliant on lawyers answering consultations, physiological limits and night/weekend working-hour constraints easily cause high-quality case sources to be missed.' }
        ]
      }
    }
  },
  product: {
    common: {
      tryNow: 'Try Now',
      featuresTitle: 'Core Capabilities'
    },
    outbound: {
      title: 'Outbound AI Voice System',
      bannerTitle: ['AI Voice Intelligent Outbound', 'Proactively reach every potential customer'],
      intro: 'Built for proactive outreach such as marketing, follow-up, invitations and notifications, replacing human agents with human-like AI outbound calling to enable massive concurrency, precise intent recognition and end-to-end automation.',
      sectionTitle: 'Core Capabilities of the Outbound AI Voice System',
      features: [
        { title: 'Ultra-high Concurrency', desc: 'Unlimited daily capacity to easily handle massive lead outreach and business peaks.' },
        { title: 'Human-like Conversation', desc: 'Highly natural voice with complex multi-turn interaction; customers can hardly tell it is AI.' },
        { title: 'Real-time Intent Scoring', desc: 'Real-time semantic analysis outputs intent scores and demand tags for precise lead screening.' },
        { title: 'End-to-end Automation', desc: 'A fully automated loop from data import, auto-dialing and form filling to data aggregation.' },
        { title: 'Compliant Smart QA', desc: 'Built-in violation detection and blocking that auto-filters sensitive words to mitigate risk.' },
        { title: 'Elastic On-demand Deployment', desc: 'Scale concurrency flexibly across seasons; ready to use with no need to retain staff.' }
      ]
    },
    inbound: {
      title: 'Inbound AI Voice System',
      bannerTitle: ['AI Voice Intelligent Inbound', 'Attentively handle every call around the clock'],
      intro: 'Built for inbound scenarios such as consultation, customer service, after-sales and business processing, replacing human agents with human-like AI answering for 24/7 reception, instant response and precise transfer.',
      sectionTitle: 'Core Capabilities of the Inbound AI Voice System',
      features: [
        { title: '24/7 Availability', desc: 'Unattended reception around the clock, with instant response even off-hours and on holidays.' },
        { title: 'Multi-turn Understanding', desc: 'Precisely understands intent, flexibly handles multi-turn dialogue and auto-transfers complex issues.' },
        { title: 'Knowledge-base Accurate Answers', desc: 'Answers strictly confined to the preset knowledge base, eliminating hallucination and ensuring accuracy.' },
        { title: 'Emotion & Dialect Awareness', desc: 'Senses customer emotion and dialect in real time, matching flows and switching comforting scripts.' },
        { title: 'Smart Transfer & Collaboration', desc: 'AI resolves standard issues instantly while complex ones transfer seamlessly to humans.' },
        { title: 'Multi-dimensional Analytics', desc: 'Every call is structured and recorded, auto-generating field capture and intent summaries.' }
      ],
    }
  },
  productOutbound: {
    hero: {
      tag: 'Outbound AI Voice System',
      titleLine1: 'Make Every Outbound Call',
      titleLine2: 'Closer to Closing the Deal',
      desc: 'Like a tireless online telemarketing manager that interacts flexibly, autonomously collects and summarizes information, auto-generates customer profiles and scores leads.',
      cta: 'Try Now'
    },
    stats: [
      'Overall cost reduction',
      'Outbound efficiency gain',
      'Full call QA coverage',
      'Compliant script tags'
    ],
    statsSuffix: [
      '%',
      'x+',
      '%',
      '%'
    ],
    pain: {
      title: 'Solve it with Shunshi AI',
      items: [
        'Manual dialing is inefficient and conversions slip away',
        'Peak and off-peak business makes seat allocation inflexible',
        'High staff turnover drives up training and recruiting costs',
        'Call data is scattered, making review impossible',
        'Long training cycles and inconsistent script quality',
        'Manual lists are error-prone and fragment customer information'
      ]
    },
    feature: {
      title: 'Use Shunshi AI to focus on telemarketing lead conversion',
      subtitleLine1: 'Multi-channel lead aggregation and batch outbound outreach',
      subtitleLine2: 'AI-driven precise marketing and efficient conversion',
      items: [
        'One-click task creation and batch data import with 10,000+ concurrent lines and 1M+ efficient touches per day',
        'AI autonomously conducts multi-turn dialogue with interruption and intent switching',
        'Autonomously completes compliant lead capture, product introduction and invitation confirmation',
        'AI auto-identifies high-intent customers and scores them to help sales follow up precisely',
        'Intelligently generates customer profiles and demand tags from call content',
        'Auto-archives recordings, transcripts and key data after each call for full QA and traceability',
        'Real-time multi-dimensional dashboards feed call results back into marketing strategy and script optimization'
      ],
      cta: 'Consult Now'
    },
    cost: {
      titlePrefix: 'Use Shunshi AI vs. manual telemarketing to save',
      titleHighlight: ' 90% every month',
      commission: 'Commission ¥1000',
      office: 'Office ¥800',
      recruit: 'Recruiting & training ¥800',
      social: 'Social insurance & housing fund ¥2000',
      salary: 'Salary ¥3000-5000',
      computeFee: 'Compute',
      aiFee: 'AI fee',
      manualTitle: 'Manual Telemarketing',
      aiTitle: 'Shunshi AI',
      desc: 'Cost estimate: AI fee + compute is about 1/10 of labor cost (phone charges optional and not included)'
    },
    efficiency: {
      titlePrefix: 'Use Shunshi AI vs. manual dialing to boost',
      titleHighlight: ' efficiency 40x+',
      manualLabel: 'Manual dialing',
      manualValue: '100-200 calls/day',
      manualSuffix: 'X seats',
      aiLabel: 'AI outbound',
      aiValue: '8000-10000 calls/day',
      aiSuffix: 'X AI seat teams',
      tip1: 'When 1 AI seat team = 10 concurrent lines, a single seat team can make 8000-10000 outbound calls per day',
      tip2: 'Where lines allow, multiple AI seat teams dialing out at the same time can reach over a million outbound calls per day, greatly improving work efficiency'
    },
    check: {
      titlePrefix: 'Use Shunshi AI for full call recording with',
      titleHighlight: ' 100% QA coverage',
      manual: 'Manual Spot Check',
      manualValue: 'Miss rate > 95%',
      ai: 'AI Full QA',
      aiValue: '100% coverage'
    },
    scene: {
      title: 'Shunshi AI, full coverage of outbound marketing scenarios',
      items: [
        { title: 'Event Notification', desc: 'Bulk outreach to potential customers' },
        { title: 'Service Follow-up', desc: 'Complete the after-sales service chain' },
        { title: 'Product Introduction', desc: 'Precise intent positioning' },
        { title: 'Questionnaire', desc: 'Rapid script template generation' },
        { title: 'Expiry Reminder', desc: 'Proactive reminder with interactive answers' },
        { title: 'Member Care', desc: 'Re-engage dormant customers' },
        { title: 'Information Confirmation', desc: 'Auto-fill forms' },
        { title: 'Event Invitation', desc: 'One-click outbound screening' }
      ]
    }
  },
  productInbound: {
    hero: {
      tag: 'Inbound AI Voice System',
      titleLine1: 'Every Incoming Inquiry',
      titleLine2: 'Answered Promptly',
      descLine1: 'Like a 24/7 customer service supervisor that precisely recognizes intent and routes calls automatically',
      descLine2: 'routes complex issues to humans and answers repeated inquiries instantly',
      cta: 'Try Now'
    },
    stats: [
      'Overall cost reduction',
      'Routine inquiries handled autonomously',
      'Uninterrupted service',
      'Instant response, zero wait'
    ],
    pain: {
      title: 'Solve it with Shunshi AI',
      items: [
        'Slow response to incoming calls hurts the customer experience',
        'Peak calls can\'t be routed while off-peak staff sit idle',
        'Long customer-service training cycles and uneven service quality',
        'No one answers at night or on holidays, leaving service gaps',
        'Call data is hard to tally, so key decisions rely on experience',
        'Repetitive questions tie up staff, neglecting high-value customers'
      ]
    },
    pyramid: {
      decisionLayer: 'Decision‑Making Layer',
      decisionTip: 'Accurate decision‑making basis',
      smartExtract: 'Intelligent Extraction',
      analysisLayer: 'Analysis Layer',
      analysisTip: 'High‑frequency demand identification · Trend research',
      autoCollect: 'Automatic Collection',
      dataLayer: 'Data Layer',
      dataTip: 'Structured management of massive consultation data'
    },
    feature: {
      title: 'Use Shunshi AI to boost inbound consultation efficiency',
      subtitleLine1: 'Unified call handling and intelligent routing',
      subtitleLine2: 'AI-driven efficient service with smart data aggregation',
      items: [
        'AI answers incoming calls in seconds, online 24/7',
        'Accurate knowledge-base answers eliminate wrong replies, with standardized product and policy interpretation',
        'AI auto-recognizes customer intent and seamlessly routes complex issues to humans with full context',
        'Auto-creates work orders and fills fields after each call, instantly forwarding complaints to the responsible department',
        'Intelligently generates customer profiles and demand tags from call content',
        'Auto-archives recordings, transcripts and key data after each call for full QA and traceability',
        'Classifies and aggregates service data and intelligently generates analysis reports',
        'Real-time multi-dimensional dashboards make consultation hotspots and seat efficiency clear at a glance'
      ],
      cta: 'Consult Now'
    },
    cost: {
      titlePrefix: 'Use Shunshi AI for',
      titleHighlight: ' elastic cost control across seasons',
      note: 'Note: the chart only illustrates how AI and labor costs fluctuate across business seasons and is schematic. The actual cost structure depends on real usage.'
    },
    efficiency: {
      title: 'Use Shunshi AI to cover night and weekend service gaps',
      dutyLabel: 'On-duty hours',
      manualTitle: 'Human Agents',
      manualTag: '↗ Hard to cover',
      manualDesc: 'Unattended at night, on weekends and holidays',
      weekday: 'Workdays',
      eightHours: '8-hour shifts',
      aiTitle: 'Shunshi AI',
      aiTag: '↗ Around the clock',
      aiDesc: 'No holidays, no weekends, no night breaks',
      allDay: '24/7'
    },
    check: {
      titlePrefix: 'Use Shunshi AI to enable',
      titleHighlight: ' digital team management'
    },
    scene: {
      title: 'Shunshi AI, full coverage of inbound consultation scenarios',
      items: [
        { title: 'Customer Hotline', desc: 'Answer customer questions efficiently' },
        { title: 'Complaints & Suggestions', desc: 'Full recording retention' },
        { title: 'Repair & Maintenance', desc: 'Auto-recording and work-order flow' },
        { title: 'Product Consultation', desc: 'Personalized recommendations' },
        { title: 'Business Handling', desc: 'Process guidance' },
        { title: 'Pre-sales & After-sales', desc: 'Rule-based returns and exchanges' },
        { title: 'Self-service Inquiry', desc: 'Auto-matches the knowledge base' },
        { title: 'Appointment Service', desc: 'Auto-extracts information' }
      ]
    }
  },
  footer: {
    company: 'Beijing Shunshi Zhongjie Technology Co., Ltd.',
    phone: 'Contact: 18755615081',
    address: 'Address: 5F, Yicheng International Center, Shangdi, Haidian District, Beijing',
    productCenter: 'Product Center',
    productOutbound: 'Outbound AI Voice System',
    productInbound: 'Inbound AI Voice System',
    scenarioTitle: 'Application Scenarios',
    scenarioGovernment: 'Government',
    scenarioLegal: 'Legal',
    scenarioCar: 'Automotive',
    wechatWork: 'WeCom',
    wechatOfficial: 'Official Account',
    copyright: '© 2026 Shunshi Zhongjie. All rights reserved. | ICP 2026030486'
  },
  popup: {
    title: 'Apply for Trial',
    subtitle: 'Submit your details and we will contact you soon',
    company: 'Company Name',
    name: 'Your Name',
    phone: 'Phone Number',
    city: 'City',
    code: 'Verification Code',
    remark: 'Requirements',
    companyPlaceholder: 'Enter company name',
    namePlaceholder: 'Enter your name',
    phonePlaceholder: 'Enter phone number',
    cityPlaceholder: 'Enter city',
    codePlaceholder: 'Enter verification code',
    remarkPlaceholder: 'Briefly describe your requirements',
    getCode: 'Get Code',
    retry: 'Retry in {n}s',
    submit: 'Submit',
    msgInvalidPhone: 'Please enter a valid phone number',
    msgCodeSent: 'Verification code sent, please check',
    msgCodeFail: 'Failed to send code, please try again later',
    msgCodeError: 'Failed to send code, please check your network or phone number',
    msgIncomplete: 'Please fill in all required fields',
    msgSubmitSuccess: 'Submitted successfully! We will contact you soon',
    msgSubmitFail: 'Submission failed, please try again later',
    msgSubmitError: 'Submission failed, please check your network or try again later'
  },
  apply: {
    title: 'Fill in Your Team Information',
    subtitle: 'A dedicated consultant will contact you within 10 minutes of submission',
    company: 'Company Name',
    companyPlaceholder: 'Enter your company name',
    city: 'Province / City',
    cityPlaceholder: 'Enter your province / city',
    phone: 'Contact',
    phonePlaceholder: 'Enter your contact information',
    code: 'Verification Code',
    codePlaceholder: 'Enter verification code',
    remarkPlaceholder: 'Enter your message',
    getCode: 'Get Code',
    retry: 'Retry in {n}s',
    submit: 'Apply Now',
    contactText: 'Or call us and let us serve you',
    msgInvalidPhone: 'Please enter a valid phone number',
    msgCodeSent: 'Verification code sent, please check',
    msgCodeFail: 'Failed to send code, please try again later',
    msgCodeError: 'Failed to send code, please check your network or phone number',
    msgIncomplete: 'Please fill in all required fields',
    msgSubmitSuccess: 'Submitted successfully! We will contact you soon',
    msgSubmitFail: 'Submission failed, please try again later',
    msgSubmitError: 'Submission failed, please check your network or try again later'
  },
  meta: {
    home: 'Shunshi Zhongjie - AI Intelligent Service Engine',
    advantage: 'Core Advantages - Shunshi Zhongjie',
    solution: 'Solutions - Shunshi Zhongjie',
    productOutbound: 'Outbound AI Voice System - Shunshi Zhongjie',
    productInbound: 'Inbound AI Voice System - Shunshi Zhongjie',
    faq: 'FAQ - Shunshi Zhongjie',
    about: 'About Us - Shunshi Zhongjie',
    description: 'Beijing Shunshi Zhongjie Technology Co., Ltd. provides next-generation AI voice model solutions for enterprises, covering automotive, government, insurance, education, finance, e-commerce and home decoration, enabling intelligent customer operations and efficient outbound calling.',
    keywords: 'AI voice outbound calling, AI voice, intelligent outbound calling system, Zhongsheng 2.0, Shunshi Zhongjie'
  },
  home: {
    tryNow: 'Try Now',
    heroTitle: 'Shunshi AI Intelligent Voice Platform',
    heroSubtitle: 'All-scenario Precision Marketing & Intelligent Service Solutions',
    heroDesc: 'Whether inbound consultation or outbound marketing, we deliver efficient AI voice intelligence solutions for you.',
    heroStatsPrefix: 'Handles ',
    heroStatsSuffix: ' calls daily',
    listenFirst: 'Listen First',
    talkCooperation: "Let's Talk",
    userTitlePrefix: 'They are all using',
    userTitleBrand: 'Shunshi AI',
    userTitleSuffix: 'to connect with users',
    userImageAlt: 'Our Users',
    recordLaw: 'Legal Industry Case',
    recordCar: 'Automotive Industry Case',
    caseTip: 'Due to client compliance requirements, brand logos are not displayed; the cooperation content and data shown are all real cases.',
    cases: [
      { name: 'Beijing Legal Firms', desc: 'In July 2026, the outbound AI voice system was deployed at scale in the legal industry.' },
      { name: 'Beijing Dongcheng Gov Office', desc: 'On July 8, 2026, the AI government consultation platform went live, truly bridging the "last mile" of convenient services.' },
      { name: 'Major Automotive Platform', desc: 'In June 2025, the outbound AI voice system completed customer validation in automotive marketing.' },
      { name: 'Insurance industry client', desc: 'The system achieved scaled deployment in the insurance industry, with AI outbound calls used for customer follow-ups and lead screening.' }
    ],
    overview: {
      title: 'Use Shunshi AI to Cut Costs and Boost Efficiency',
      desc: 'Proactive outbound outreach  •  Precise inbound response',
      outbound: {
        title: 'Outbound AI Voice System',
        subtitle: 'Low-cost bulk outreach and intelligent screening to lock in high-intent customers, suited to marketing scenarios across industries',
        items: ['Total cost down 90%+', 'Efficiency up 40x+', '1M+ outbound calls per day']
      },
      inbound: {
        title: 'Inbound AI Voice System',
        subtitle: 'Round-the-clock inquiry handling, intelligent routing and standardized answers to smoothly manage peak call volumes',
        items: ['24/7 uninterrupted service', 'Covers 95% of inquiry categories', 'Elastic scaling, flexible concurrency']
      },
      government: {
        title: 'AI Government Consultation Platform',
        subtitle: 'Round-the-clock intelligent policy interpretation, automated triage and guidance for cross-department coordination, letting citizens get things done in one visit',
        items: ['Covers night and weekend service gaps', 'Private deployment with physical data isolation', 'Work orders and reports generated automatically']
      },
      detail: 'Learn More'
    },
    serviceUpgrade: {
      title: 'Use Shunshi AI to Upgrade Your Service Experience',
      desc: 'Simple, easy to use, powerful — AI capabilities that keep evolving',
      naturalTitle: 'Make AI conversations more natural, closer to a real person',
      naturalItems: [
        { title: 'Real voice cloning', desc: 'Generate voices nearly indistinguishable from real people to build your own voice identity' },
        { title: 'Real-time speech synthesis', desc: 'Low-latency voice generation as natural and fluent as a human agent in conversation' },
        { title: 'Multi-dialect recognition', desc: 'Intelligently recognizes dozens of dialects to meet multi-scenario business needs across industries' },
        { title: 'Accurate speech recognition', desc: 'Intelligently handles noisy environments and automatically follows up on faint or unclear speech' },
        { title: 'Human-like interaction', desc: 'Supports interruptions, topic shifts and follow-up questions for complex multi-turn conversations' }
      ],
      quickDeploy: {
        title: 'Rapid modeling and launch, no lengthy training',
        desc1: 'Pre-built industry scripts, models generated quickly after requirements are confirmed',
        desc2: 'Live within one week, zero long-term training',
        node1: 'Requirements',
        node2: 'Development',
        node3: 'Test',
        node4: 'Maintenance',
        flywheel: {
          intake: 'Business Onboarding',
          test: 'Evaluation & Launch',
          strategy: 'Strategy Iteration',
          service: 'Live Service'
        }
      },
      deploy: {
        title: 'SaaS / Private dual deployment modes',
        desc1: 'SaaS version ready to use out of the box',
        desc2: 'For confidential and government scenarios, local independent deployment balancing flexibility and data security'
      },
      digitalHuman: {
        title: 'Digital human visual integration for an upgraded experience',
        desc1: 'Optional digital human avatar on the front end',
        desc2: 'Voice + visual two-way interaction for a more immersive customer experience'
      },
      consult: 'Consult Now'
    },
    workflow: {
      title: 'Use Shunshi AI to Build a Lead Outreach - Data Retention Closed Loop',
      desc: 'One AI voice system covering lead outreach, customer service and data review end to end',
      steps: [
        { title: 'Customer Connection', desc1: 'Batch data import', desc2: 'or inbound integration' },
        { title: 'Intelligent Communication', desc1: 'Multi-turn natural dialogue', desc2: 'Precise intent recognition' },
        { title: 'Intent Screening', desc1: 'Automatic scoring and grading', desc2: 'High-potential customer tagging' },
        { title: 'Lead Follow-up', desc1: 'Automatic work order creation', desc2: 'Seamless handoff to human agents' },
        { title: 'Data Optimization', desc1: 'Full data retention', desc2: 'Call analysis reports' }
      ]
    },
    whyChoose: {
      title: 'Why Choose Shunshi AI',
      desc: 'Dedicated vertical-scenario model training so AI truly understands your business',
      items: [
        { title: 'Deep vertical scenarios, stronger model fit', desc: 'Specialized training for government, automotive, law firm and other niche tracks, with dialogues aligned to real industry workflows' },
        { title: 'Proven in government and enterprise, mature and reusable', desc: 'Batch deployments in government sub-districts and commercial vertical platforms, validated in real business scenarios with mature and stable solutions' },
        { title: 'Peking University team self-developed algorithms, stable and fast iterating', desc: 'An algorithm team from Peking University, Renmin University and Central University of Finance and Economics develops proprietary language algorithms that are stable and fast iterating' },
        { title: '12+ years of technical experience, professional operations', desc: 'The core technical team has rich model deployment experience and provides 24/7 professional service' }
      ]
    },
    application: {
      title: 'Evolve with AI across every industry calling scenario',
      desc: 'Configurable knowledge bases, dedicated model training and 1-on-1 service',
      detail: 'View Details'
    },
    industries: {
      car: 'Automotive',
      finance: 'Finance',
      commerce: 'E-commerce',
      education: 'Education',
      insurance: 'Insurance',
      government: 'Government',
      homeDecoration: 'Home Decoration',
      law: 'Legal'
    }
  },
  advantage: {
    bannerLine1: 'Built on core AI technology',
    bannerHighlight1: 'Delivering industry-leading',
    bannerHighlight2: 'intelligent voice solutions',
    techTitle: 'Innovation-driven Technology System',
    techDesc: 'Self-developed core technology, continuously innovating and iterating',
    coreTitle: 'Three Core Advantage Engines',
    coreDesc: 'Lower costs, higher efficiency, and better service quality',
    items: [
      {
        title: 'Lower Costs',
        subtitle: 'Replace human agents with AI — no recruiting, no training, flexible schedules',
        details: [
          { title: 'Human-like AI conversations that replace agents', text: '95% of users cannot tell it apart from a human. It can replace repetitive roles such as customer service, follow-up and invitations, dramatically cutting labor costs.' },
          { title: 'Ready to use, elastically deployed on demand', text: 'Scale concurrent lines up or down with business peaks and troughs — add capacity anytime during peak seasons, zero idle during off-seasons, with no need to keep staff for short-term needs. It eliminates the recruiting-training-attrition cycle, driving management costs toward zero.' },
          { title: 'More flexible, controllable service hours', text: 'Within legally permitted hours, full-response custom time slots are supported — no scheduling, no overtime pay, and greatly reduced operating costs.' }
        ]
      },
      {
        title: 'Boost Efficiency',
        subtitle: 'End-to-end automation from data to results, massive concurrency for instant reach',
        details: [
          { title: 'Ultra-high concurrency, millions of reach-outs per day', text: 'Where lines and time slots allow, over a million outbound calls can be made per day — unattainable by human agents — with business batch-processing efficiency soaring.' },
          { title: 'Fully automated closed-loop outbound calling', text: 'From data import → automatic outbound calling → real-time intent scoring during calls → automatic form filling → financial aggregation → intelligent analysis and recommendations, the entire chain is automated.' },
          { title: 'Real-time lead intent scoring for precise screening', text: 'Based on conversational semantics analysis and field capture across multiple dimensions, lead intent scores are output — high-score leads are continuously pursued, low-score leads are nurtured automatically, greatly improving conversion.' }
        ]
      },
      {
        title: 'Improve Service Quality',
        subtitle: 'Precise AI responses, freeing staff to focus on high-value service',
        details: [
          { title: 'AI handles high-frequency, standardized inquiries', text: 'Natural voice, flexible multi-turn interaction, and automatic answers to common questions (business inquiries, product explanations, etc.) based on industry knowledge bases — with instant response.' },
          { title: 'Free staff to focus on deeper service', text: 'Employees are freed from repetitive Q&A to focus on complex matters, relationship building, and personalized solution design, significantly improving overall service quality and customer perception.' },
          { title: 'Data-driven continuous service optimization', text: 'Every conversation is fully recorded and analyzed, so the model keeps improving — the more it is used, the better it understands the business and customers, steadily raising service standards.' }
        ]
      }
    ],
    tech: [
      { title: 'Self-developed AI Voice Model', desc: 'A self-developed AI voice application model built on large models, with higher recognition accuracy' },
      { title: 'Instant Response', desc: 'Distributed architecture design ensures instant response under high-concurrency scenarios' },
      { title: 'Multi-language Support', desc: 'Supports Chinese, English and multiple dialects to meet global business needs' },
      { title: 'Flexible Deployment', desc: 'Supports local deployment of large models and flexible resource configuration on demand' }
    ]
  },
  faq: {
    bannerTitle: 'Zhongsheng 2.0',
    bannerSub: 'FAQ',
    bannerDesc: 'Covers key questions on product experience, technical implementation, partnership channels, and feature details — find the answers you need quickly.',
    product: {
      title: 'Product Overview',
      q: 'What is Zhongsheng 2.0?',
      a: 'Zhongsheng 2.0 is an AI voice interaction solution developed by Beijing Shunshi Zhongjie Technology Co., Ltd. to meet the demand for intelligent service upgrades. Focusing on AI outbound calling and consultation scenarios, it addresses surging customer inquiry volume, high labor costs, off-hours service gaps, and the pain points of poor outbound experience, low efficiency and difficult intent screening. Built for marketing centers, customer service centers and grassroots service windows, it precisely serves sales follow-up and consultation needs, turning every call into quantifiable customer insight and making service more efficient, friendlier and smarter.',
      coreTitle: 'Core advantages:',
      advantages: [
        'Handles complex conversation scenarios with multi-turn interaction, accurately understanding and recording core user needs and key fields.',
        'Answers are strictly confined to the preset knowledge base, eliminating model hallucination and ensuring no wrong or off-topic replies.',
        'Highly human-like voice with zero-latency response, delivering a natural conversation experience comparable to a real person.',
        'Offers the most competitive pricing among voice models at the same audio quality and performance level.'
      ]
    },
    launch: {
      title: 'Launch Time',
      q1: 'How long does it take to go live?',
      intro: 'We offer flexible launch options:',
      items: [
        { tag: 'Instant Access', title: 'Standard Edition', desc: 'Ready to use out of the box' },
        { tag: 'Fast Customization', title: 'Custom Configuration', desc: 'Completed and live within 5-7 days' },
        { tag: 'Deep Tuning', title: 'Professional Tuning', desc: 'Tailored to specific industry scenarios for optimal results' }
      ],
      q2: 'How many calls can be made per day?',
      callNum: 'Over one million',
      callDescBefore: 'Single-session outbound concurrency reaches as high as',
      callDescAfter: ', supporting elastic scaling and flexible concurrency adjustment based on business needs and budget.',
      tipBefore: 'When lines and time windows permit, a single day can deliver',
      tipStrong: 'over one million',
      tipAfter: 'outbound calls, greatly improving business efficiency.'
    },
    security: {
      title: 'Data Security & Compliance',
      q: 'How is data security ensured?',
      intro: 'We provide multi-level data security solutions to keep customer data safe:',
      items: [
        { title: 'Encrypted Transmission', desc: 'Supports end-to-end encrypted transmission to ensure data security during calls' },
        { title: 'Confidentiality Agreements', desc: 'Strict internal management plus signed confidentiality agreements to prevent data misuse' },
        { title: 'User-Controlled Data', desc: 'We only deliver model capability — user data is never touched or retained and can be deleted anytime, with users in full control' },
        { title: 'Private Deployment', desc: 'Private deployment options for customers with high security requirements' }
      ],
      note: 'We always put data security first and strictly comply with relevant laws, regulations and industry standards.'
    },
    effect: {
      title: 'Effect Validation',
      q: 'How is AI outbound calling effectiveness evaluated?',
      intro: 'We build a complete evaluation system across four dimensions — cost, efficiency, service quality and compliance risk:',
      headers: ['Dimension', 'Indicator', 'Traditional Manual Calling', 'Other AI Models', 'Zhongsheng 2.0'],
      rows: [
        { dimension: 'Cost', indicators: [
          { name: 'Labor cost', manual: 'Salary and benefits', other: 'Some customization fees', ours: '¥0 (ready to use)' },
          { name: 'Recruiting, training, premises & operations', manual: 'Ongoing investment, hundreds to thousands per person', other: 'Some manual tuning required', ours: '¥0 (assisted tuning)' },
          { name: 'Off-season cost', manual: 'Payroll continues as usual', other: 'Idle resources', ours: 'Zero idle (pay as you go)' }
        ] },
        { dimension: 'Efficiency', indicators: [
          { name: 'Daily reach per seat', manual: '200-300 calls', other: '500-2,000 calls', ours: 'Over one million' },
          { name: 'Intent screening & routing', manual: 'Manual screening, time-consuming', other: 'Low intent accuracy, delayed routing', ours: 'High intent accuracy, real-time routing' },
          { name: 'Data entry speed & error rate', manual: '1-3 min/record, manual entry, low accuracy', other: 'Mechanical recognition, low accuracy', ours: 'Real-time recognition, auto-correction, auto-fill, high accuracy' }
        ] },
        { dimension: 'Service Quality', indicators: [
          { name: 'Conversation naturalness', manual: 'Varies by individual', other: 'Some mechanical feel or latency', ours: '95% of users perceive a real person' },
          { name: 'Complex conversation ability', manual: 'Handles multi-turn but tires easily', other: 'Mostly simple multi-turn, easily off-topic', ours: 'Supports complex multi-turn with precise understanding and recording' },
          { name: 'Answer accuracy', manual: 'Prone to mistakes, inconsistent standards', other: 'Prone to model hallucination', ours: 'Strictly confined to knowledge base, no hallucination or wrong answers' },
          { name: 'Service consistency', manual: 'Affected by mood and skill', other: 'Relatively stable', ours: 'Highly stable, always at its best' },
          { name: 'Multi-dimensional statistics', manual: 'Manual, few annotations', other: 'Basic reports', ours: 'Structured per-call summary: field extraction and intent scoring' }
        ] },
        { dimension: 'Compliance Risk', indicators: [
          { name: 'Compliance risk & management blind spots', manual: 'Easy to miss key authorizations or use non-compliant tech; hard to supervise, risk of data leakage', other: 'Requires manual QA or extra paid QA models', ours: 'Built-in smart recognition and blocking that auto-filters non-compliant words and mitigates compliance risk' }
        ] }
      ]
    },
    custom: {
      title: 'Scenario Customization',
      q: 'Can custom scenarios be supported?',
      intro: 'Yes, we support deep customization:',
      items: ['Industry-specific knowledge base', 'Custom script logic', 'Special scenario adaptation', 'System integration needs']
    },
    cooperation: {
      title: 'Partnership & Commercial Policy',
      q1: 'Is there a trial?',
      intro1: 'We provide 1-on-1 dedicated industry consulting with zero-cost trial:',
      items1: ['Free trial', 'Dedicated consultant', 'Effect evaluation', 'Custom solution'],
      q2: 'Is there a channel policy?',
      intro2: 'We welcome all kinds of partners:',
      items2: ['Agency policy', 'Technology partners', 'Industry solution partners', 'Strategic partners'],
      note: 'Specific cooperation models and revenue-sharing plans are introduced in detail by our commercial team. We are committed to building a win-win ecosystem.'
    },
    support: {
      title: 'Technical Support & After-Sales',
      q1: 'What is the technical support response time?',
      intro1: 'We provide a multi-level technical support system:',
      items1: ['7×24 online support', 'Dedicated technical consultant', 'In-depth technical training', 'Tiered issue handling'],
      q2: 'Will the product be continuously updated?',
      intro2: 'Yes, we continuously invest in R&D:',
      items2: [
        { strong: 'Regular feature updates: ', text: 'releases feature optimizations and new functions on a regular basis' },
        { strong: 'Technology upgrades: ', text: 'continuously optimizes product performance based on the latest AI technology' },
        { strong: 'Customer demand response: ', text: 'high-quality customer needs are continuously incorporated into development plans' },
        { strong: 'Industry trend tracking: ', text: 'keeps pace with industry trends to maintain product competitiveness' }
      ],
      note: 'Our team comes from Peking University, Renmin University of China, Central University of Finance and Economics and other top institutions, with deep expertise in large language models, core algorithms and software development, keeping the product at the forefront of technology.'
    },
    title: 'Shunshi AI Intelligent Voice System',
    highlight: 'FAQ',
    tabs: [
      'All',
      'Product Overview',
      'Product Experience',
      'Pricing',
      'Launch Timeline',
      'Features',
      'Data Security',
      'Effect & Connection Rate'
    ],
    items: [
      { cat: 1, question: 'What is the Shunshi AI Intelligent Voice System?', answer: 'The Shunshi AI Intelligent Voice System is an AI voice application product built on a large model base. It focuses on outbound marketing and inbound customer service scenarios, providing a full-link AI phone solution designed to replace repetitive phone labor and effectively address surging customer inquiries, high labor costs, after-hours service gaps, low outbound efficiency and difficult intent screening.' },
      { cat: 1, question: 'Which scenarios is this product suitable for?', answer: 'It is designed for marketing centers, customer service centers and service hotlines. Its core value lies in delivering round-the-clock, high-quality, efficient and infinitely replicable phone service at extremely low cost, free from constraints of time, staffing and emotion; at the same time, it turns every call into quantifiable user insight, making service more efficient, friendlier and smarter.' },
      { cat: 2, question: 'How does it differ from traditional phone robots?', answer: 'Shunshi AI is not a robot that plays recordings. Built on a large model base, it can conduct complex multi-turn conversations, understand customer intent, support interruption and respond more flexibly. It independently handles over 95% of routine business. Complex or special issues are seamlessly transferred to human agents with the conversation context, so staff only handle the high-value parts.' },
      { cat: 2, question: 'How many calls can it make in a day?', answer: 'Outbound: a single AI seat team (10 concurrent lines) can make up to 8000-10000 outbound calls per day. For larger scale, add more AI seat teams — daily outbound volume can reach one million calls. Inbound: billed by concurrent lines with no limit on total call volume.' },
      { cat: 3, question: 'How is it billed? Roughly how much?', answer: 'It is mainly the number of AI seat teams (each AI seat team has 10 concurrent lines) + computing power, billed monthly. The monthly fee for one AI seat team (including computing power) is about 1/10 of a human agent cost, with no additional costs for social insurance, recruitment or office space. Seats can be flexibly added or removed to match seasonal business. (Phone charges are optional and not included.)' },
      { cat: 3, question: 'Are there other fees besides the monthly fee?', answer: 'The main costs are the AI seat team service fee and computing power fee, which already include system usage and technical support. For phone line fees, enterprises can apply directly to carriers; we provide line-selection guidance.' },
      { cat: 4, question: 'How long from signing to go-live?', answer: 'A standardized product can go live in as fast as one week, including needs research, script configuration and testing. Deep customization takes about 2-4 weeks.' },
      { cat: 4, question: 'What is the go-live process?', answer: 'A standard 5-step process:\n1) Needs research;\n2) Solution customization;\n3) System deployment and training;\n4) Small-scale trial and optimization;\n5) Full rollout. A dedicated person follows up throughout.' },
      { cat: 5, question: 'Can the AI voice be selected or customized?', answer: 'Multiple standard voices (both male and female) are available. Voice cloning is also supported — you can upload a recording to create a custom brand voice.' },
      { cat: 5, question: 'Can it integrate with our own CRM system?', answer: 'Yes. Standard APIs are provided. After integration you get: outbound calls carrying customer info, call results and recordings automatically written back to the CRM, and outbound tasks auto-triggered from CRM data, forming a closed data loop.' },
      { cat: 6, question: 'Is call data secure? Will customer information leak?', answer: 'A three-tier security scheme is provided:\n1) Sign a confidentiality agreement;\n2) Customers can use their own lines to dial, with AI only answering;\n3) End-to-end financial-grade encryption, with data retained as agreed or downloadable for self-management by the enterprise.' },
      { cat: 6, question: 'How is data secured in the government consulting edition?', answer: 'The government consulting platform uses local independent deployment; all data is stored on your designated server, physically isolated from the public internet, guaranteeing 100% data sovereignty and security.' },
      { cat: 7, question: 'What is the typical outbound connection rate?', answer: 'The connection rate is jointly affected by line quality, outbound timing, number freshness and region. Using carrier real-name cards and calling fresh numbers on weekdays 9:30-12:00 & 14:00-18:00 yields the best results, typically matching a human team.' },
      { cat: 7, question: 'How to ensure call quality and conversion?', answer: 'Results depend on "script quality" and "lead quality". We provide industry script templates and optimization services, and recommend continuously updating your high-quality lead pool. AI consistently executes the best scripts, avoiding the effect loss caused by human state fluctuation.' }
    ]
  },
  about: {
    title: 'About',
    titleHighlight: 'Shunshi Zhongjie',
    intro: [
      'Beijing Shunshi Zhongjie Technology Co., Ltd. is located in the heart of the AI innovation hub in Haidian District, Beijing — a technology company deeply focused on the AI voice track. Centered on its self-developed voice application models, the company distills top talent into standardized, reusable AI models, helping customers deploy professional phone-service capabilities to every call node. We help enterprises achieve 24/7 intelligent answering with no busy lines, precise lead screening and full-process service tracking — truly turning "cost reduction and efficiency gains" into every call.',
      'Today, our business spans government, finance, insurance, automotive, education, e-commerce, home decoration, law firms and more, accumulating rich vertical-scenario deployment experience.'
    ],
    timelineTitle: 'Company Milestones',
    timeline: [
      { year: 'Jul 2026', desc: 'Outbound AI voice system began scaled replication in law firms, insurance and other sectors' },
      { year: 'Mar 2026', desc: 'Inbound AI voice system put into use at Yongwai Sub-district Office, Dongcheng District, Beijing' },
      { year: 'Oct 2025', desc: 'Inbound AI voice system launched, completing the "inbound + outbound" product loop' },
      { year: 'Jun 2025', desc: 'Outbound AI voice system validated in the automotive marketing field' },
      { year: 'Apr 2025', desc: 'Outbound AI voice system launched, achieving commercial deployment' },
      { year: 'Feb 2024', desc: 'Core algorithm team focused on developing self-developed voice application models' },
      { year: 'Oct 2023', desc: 'Company officially founded, starting its AI voice application track' }
    ],
    teamTitle: 'Core Team',
    teamSub: '10+ years of team operations experience + senior AI technical team + deep delivery',
    teamMembers: [
      {
        name: 'Wang Hansheng',
        post: 'Partner',
        desc: 'Professor and doctoral supervisor, Guanghua School of Management, Peking University\nDistinguished Professor, Changjiang Scholars Program, Ministry of Education\nAmong the earliest scholars in China to study search-engine marketing, social-network data and location-trajectory data from a statistical data-analysis perspective'
      },
      {
        name: 'Bai Xuefeng',
        post: 'Founder',
        desc: 'M.A., Communication University of China; EMBA, Guanghua School of Management, Peking University\nNearly two decades of team operations and management experience\nIn-depth understanding of traditional human telemarketing and the limitations of conventional AI\nProvides strategic direction for AI deployment in the enterprise market'
      },
      {
        name: 'Pan Rui',
        post: 'Algorithm Director',
        desc: 'Professor and doctoral supervisor, School of Statistics and Mathematics, Central University of Finance and Economics\nLongma Scholar (Young Scholar), Central University of Finance and Economics\nResearch focuses on statistical modeling of network-structured data and spatio-temporal data analysis'
      },
      {
        name: 'Technical Team',
        post: 'Algorithm Team',
        desc: 'A high-caliber algorithm team from Peking University, Renmin University of China, Central University of Finance and Economics and other top institutions — 8 PhDs and over 10 masters\nDeep expertise and cutting-edge exploration in large language models, core algorithms and software development'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js